// src/components/store/sections/testimonials/TestimonialV44ClayreviewsTealLagoon.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV44ClayreviewsTealLagoon(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={44}
      archKey="clay_reviews"
      archLabel="3D Clay Review Deck"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
